export default "__VITE_ASSET__C2Ei0Ack__"